import * as A from 'fp-ts/Array';
const scales = [25, 50, 75, 100, 125, 150, 175, 200];
const scalesReversed = A.reverse(scales);
export function increaseScale(oldScale) {
    let newScale = scalesReversed.find(scale => scale < oldScale);
    if (newScale !== undefined) {
        return newScale;
    }
    else {
        return 25;
    }
}
export function decreaseScale(oldScale) {
    let newScale = scales.find(scale => scale > oldScale);
    if (newScale !== undefined) {
        return newScale;
    }
    else {
        return 200;
    }
}
// export function setScaleWithFocus(oldScale: number, oldTranslation: Vector, focus: Vector): [number, Vector] {
//     const deltaTranslationScaleX = (1 - newScale/scale) * (event.offsetX - translation.x);
//     const deltaTranslationScaleY = (1 - newScale/scale) * (event.offsetY - translation.y);
// }
